package dev.moetz.sslcertificatetool

import dev.moetz.sslcertificatetool.page.ChannelPageService
import dev.moetz.sslcertificatetool.page.ChannelPageServiceManager
import dev.moetz.sslcertificatetool.page.DomainPageService
import dev.moetz.sslcertificatetool.page.DomainPageServiceManager
import dev.moetz.sslcertificatetool.page.DomainPageTab
import dev.moetz.sslcertificatetool.page.NotFoundPageService
import kotlinx.browser.window
import react.create
import react.dom.client.createRoot
import web.dom.document
import kotlin.uuid.ExperimentalUuidApi

@ExperimentalUuidApi
fun main() {
    val container = document.createElement("div")
    document.body.appendChild(container)

    val path = window.location.pathname
    val pathSplit = path.split("/")
        .filter { it.isNotBlank() }

    val element = when {
        path.isBlank() || path == "/" -> {
            ChannelPageService.create {
                manager = ChannelPageServiceManager()
            }
        }

        pathSplit.getOrNull(0) == "domain" && pathSplit.size >= 2 -> {
            val id = pathSplit.getOrNull(1)?.toUuidOrNull()
            if (id != null) {
                val tabPath = pathSplit.getOrNull(2)
                    ?.let { DomainPageTab.entries.firstOrNull { tab -> tab.pathName == it } }
                when (tabPath) {
                    DomainPageTab.OpenSSL -> {
                        DomainPageService.create {
                            manager = DomainPageServiceManager(
                                id = id,
                                DomainPageTab.OpenSSL,
                            )
                        }
                    }
                    DomainPageTab.SCT -> {
                        DomainPageService.create {
                            manager = DomainPageServiceManager(
                                id = id,
                                DomainPageTab.SCT,
                            )
                        }
                    }

                    DomainPageTab.General, null -> {
                        DomainPageService.create {
                            manager = DomainPageServiceManager(
                                id = id,
                                DomainPageTab.General,
                            )
                        }
                    }
                }
            } else {
                NotFoundPageService.create {

                }
            }
        }

        else -> {
            NotFoundPageService.create {

            }
        }
    }

    createRoot(container).render(element)
}